import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import CustomEase from 'gsap/CustomEase';

gsap.registerPlugin( ScrollTrigger, ScrollSmoother, CustomEase );

export class Smoother {
	constructor( selector, options = {} ) {
		this.container = document.querySelector( selector );
		this.options = options;
		this.isEnable = false;
	}

	init() {
		if ( this.isEnable ) return;
		this.isEnable = true;
		const generalProps = {};
		if ( this.options.smooth || this.options.smooth === 0 )
			generalProps.smooth = this.options.smooth;
		if ( this.options.smoothTouch || this.options.smoothTouch === 0 )
			generalProps.smoothTouch = this.options.smoothTouch;
		if ( this.options.effects ) generalProps.effects = this.options.effects;
		if ( this.options.customEase ) {
			generalProps.ease = CustomEase.create(
				'custom',
				this.options.customEase
			);
		} else if ( this.options.ease ) {
			generalProps.ease = this.options.ease;
		} else {
			generalProps.ease = 'expo';
		}
		const theContent = this.container.firstElementChild;
		ScrollSmoother.create( {
			wrapper: this.container,
			content: theContent,
			...generalProps,
		} );
	}

	kill() {}

	resize() {
		ScrollSmoother.update();
	}

	destroy() {
		this.isEnable = false;
		ScrollSmoother.destroy( this.container );
	}
}
